import { mapGetters } from 'vuex'
import i18n from '@/plugins/i18n'

const AVAILABLE_LOCALES = [
  { locale: 'pt-BR', labelKey: 'portuguesbrasil' },
  { locale: 'es', labelKey: 'espanhol' },
  { locale: 'en', labelKey: 'ingles' }
]

export default {
  computed: {
    ...mapGetters(['name', 'userProfile', 'userTypeName', 'locale']),
    firstName() {
      return (this.name || '').split(' ')[0] || ''
    },
    profileLabel() {
      if (this.userTypeName) return this.userTypeName
      return this.userProfile ? this.$t(this.userProfile) : ''
    },
    currentLocale() {
      return this.locale || i18n.locale
    },
    availableLocales() {
      return AVAILABLE_LOCALES
    }
  },
  methods: {
    changeLocale(locale) {
      i18n.locale = locale
      this.$store.state.user.locale = locale
      localStorage.setItem('lastLocale', locale)
    },
    async logout() {
      await this.$store.dispatch('user/logout')
    }
  }
}
